import { Component, input } from '@angular/core';

import { MobiUiIconComponent } from '@mobi/rwc-ui-components-ng-jslib';
import { mobiIcon } from '@mobi/rwc-utils-icons-jslib';
import { ComponentSharedModule } from '@app/modules/component.shared.module';

@Component({
  selector: 'mobi-misc-item',
  templateUrl: './misc-item.component.html',
  styleUrls: ['./misc-item.component.scss'],
  standalone: true,
  imports: [ComponentSharedModule, MobiUiIconComponent],
})
export class MiscItemComponent {
  readonly title = input<string | undefined>();
  readonly content = input<string | undefined>();
  readonly icon = input<mobiIcon | undefined>();
}
